// Namespace for auth actions...
const NAMESPACE = 'auth@'

export const LOGIN = `${NAMESPACE}LOGIN`
export const LOGIN_LOADING = `${NAMESPACE}LOGIN_LOADING`
export const LOGIN_FAILURE = `${NAMESPACE}LOGIN_FAILURE`
export const LOGIN_SUCCESS = `${NAMESPACE}LOGIN_SUCCESS`

export const login = credentials => ({
  type: LOGIN,
  payload: { credentials },
})

export const CLEAR_LOGIN_ERROR = `${NAMESPACE}CLEAR_LOGIN_ERROR`
export const clearLoginError = () => ({
  type: CLEAR_LOGIN_ERROR,
})

export const AUTH_WITH_TOKEN_LOADING = `${NAMESPACE}AUTH_WITH_TOKEN_LOADING`
export const AUTH_WITH_TOKEN_FAILURE = `${NAMESPACE}AUTH_WITH_TOKEN_FAILURE`
export const AUTH_WITH_TOKEN_SUCCESS = `${NAMESPACE}AUTH_WITH_TOKEN_SUCCESS`

export const LOGOUT = `${NAMESPACE}LOGOUT`

export const logout = () => ({
  type: LOGOUT,
})

export const REFRESH_TOKEN_LOADING = `${NAMESPACE}REFRESH_TOKEN_LOADING`
export const REFRESH_TOKEN_FAILURE = `${NAMESPACE}REFRESH_TOKEN_FAILURE`
export const REFRESH_TOKEN_SUCCESS = `${NAMESPACE}REFRESH_TOKEN_SUCCESS`

export const UPDATE_USER = `${NAMESPACE}UPDATE_USER`
export const updateUser = user => ({
  type: UPDATE_USER,
  payload: user,
})

export const DELETE_ACCOUNT = `${NAMESPACE}DELETE_ACCOUNT`
export const DELETE_ACCOUNT_LOADING = `${NAMESPACE}DELETE_ACCOUNT_LOADING`
export const DELETE_ACCOUNT_FAILURE = `${NAMESPACE}DELETE_ACCOUNT_FAILURE`
export const DELETE_ACCOUNT_SUCCESS = `${NAMESPACE}DELETE_ACCOUNT_SUCCESS`

export const deleteAccount = () => ({
  type: DELETE_ACCOUNT,
})

export const CLEAR_DELETE_ACCOUNT_ERROR = 'CLEAR_DELETE_ACCOUNT_ERROR'
export const clearDeleteAccountError = () => ({
  type: CLEAR_DELETE_ACCOUNT_ERROR,
})



// WEBPACK FOOTER //
// ./src/actions/auth.js